import { useUniqueId, useMedia, useReducerState, useRef, useEffect, useCallback } from 'sb-hooks'
import mixpanel from 'common/helpers/analytics/mixpanel'


const initialState = {
  isVisible: false,
  isClicked: false,
}

const useCvcHelpPopup = (isHumble = false) => {
  const [ { isVisible, isClicked }, setState ] = useReducerState(initialState)
  const { isMobile } = useMedia()
  const popupId = useUniqueId('cardHelp_')
  const popupContainerRef = useRef(null)

  const withHover = !isMobile && !isHumble

  const handleHoverIn = useCallback(() => setState(({ isClicked }) => ({ isVisible: isClicked || true })), [])
  const handleHoverOut = useCallback(() => setState(({ isClicked }) => ({ isVisible: isClicked || false })), [])

  const handleOpen = useCallback(() => {
    mixpanel.track('Cvc help icon click')
    setState({ isVisible: true, isClicked: true })
  }, [])

  const handleClose = useCallback(() => setState({ isVisible: false, isClicked: false }), [])

  useEffect(() => {
    if (withHover) {
      popupContainerRef.current.addEventListener('mouseover', handleHoverIn)
      popupContainerRef.current.addEventListener('mouseout', handleHoverOut)
    }

    return () => {
      if (withHover) {
        popupContainerRef.current.removeEventListener('mouseover', handleHoverIn)
        popupContainerRef.current.removeEventListener('mouseout', handleHoverOut)
      }
    }
  }, [])

  return {
    handleOpen,
    handleClose,
    popupId,
    popupContainerRef,
    isVisible,
    isClicked,
  }
}


export default useCvcHelpPopup
